<agpr-dialog-container
    [id]="'saveAsGroupDialog'"
    heading="SourceGroups.saveAsDialog.heading"
    (close)="cancel()"
>
    <div class='agpr-saveAsGroupDialog'>
        <div *ngIf="showSaveAsOptions" class="agpr-saveAsGroupDialog-saveAsOptions">
            <agpr-radio
                [id]="'saveAsGroupDialog_new'"
                name="saveAsOption"
                label="SourceGroups.saveAsDialog.saveAsNew"
                [value]="saveAsOptions.saveAsNew"
                [(ngModel)]="saveAsOption"
            ></agpr-radio>
            <agpr-radio
                [id]="'saveAsGroupDialog_existing'"
                name="saveAsOption"
                label="SourceGroups.saveAsDialog.saveToExisting"
                [value]="saveAsOptions.saveToExisting"
                [(ngModel)]="saveAsOption"
            ></agpr-radio>
        </div>
        <div
            *ngIf="saveAsOption === saveAsOptions.saveAsNew"
            class="agpr-saveAsGroupDialog-saveAsNew"
        >
            <agpr-text-input
                [id]="'saveAsGroupDialog_groupName'"
                label="SourceGroups.createDialog.name"
                placeholder="SourceGroups.createDialog.name.placeholder"
                [(ngModel)]="groupName"
                [required]="true"
                (ngModelChange)="validateName()"
                ariaDescribedBy="saveAsGroupDialog_groupNameErrors"
            ></agpr-text-input>
            <div
                *ngIf="groupNameErrors.length"
                [id]="'saveAsGroupDialog_groupNameErrors'"
                class="agpr-saveAsGroupDialog-saveAsNew-errors"
            >
                <agpr-form-message
                    *ngFor="let error of groupNameErrors"
                >
                    {{ error | localize }}
                </agpr-form-message>
            </div>
        </div>

        <div
            *ngIf="saveAsOption === saveAsOptions.saveToExisting"
            class="agpr-saveAsGroupDialog-saveToExisting"
        >
            <agpr-dropdown
                [id]="'saveAsGroupDialog_groups'"
                label="SourceGroup"
                placeholder="SourceGroups.saveAsDialog.existingGroup.placeholder"
                [options]="groupOptions"
                [(ngModel)]="selectedGroup"
                (ngModelChange)="selectedGroupChanged()"
            ></agpr-dropdown>
        </div>

        <div class="agpr-saveAsGroupDialog-selectedSources">
            <label class="agpr-saveAsGroupDialog-selectedSources-label"> {{ 'SourceGroups.saveAsDialog.selectedSources' | localize }} </label>
            <agpr-scroll-panel>
                <ul *ngIf="selectedSources.length" class="agpr-saveAsGroupDialog-chipList">
                    <li
                        *ngFor="let source of selectedSources; index as i"
                        class="agpr-chip"
                    > 
                        <span class="agpr-chip-label"> {{ source.displayString }} </span>
                        <span class="agpr-chip-type"> {{ typeToStringMap[source.entityType] }} </span>
                        <button
                            [id]="'saveAsGroupDialog_includedSources_' + i + '_delete'"
                            class="agpr-chip-icon agpr-i-close"
                            agprTooltip="Common.forms.chips.delete"
                            [useTooltipAsAriaLabel]="false"
                            tooltipPosition="top"
                            (click)="removeSource(source)"
                            [attr.aria-label]="source.displayString + ' ' + ('Common.forms.chips.delete' | localize)"
                        ></button>
                    </li>
                </ul>
            </agpr-scroll-panel>
        </div>
        <div class="agpr-saveAsGroupDialog-selectedGroups">
            <agpr-checkbox
                [id]="'saveAsGroupDialog_includedSourceGroups'"
                label="SourceGroups.saveAsDialog.includeGroups"
                [binary]="true"
                [(ngModel)]="includeSourcesFromGroups"
                [disabled]="!includedSourceGroups.length"
            ></agpr-checkbox>
            <agpr-scroll-panel>
                @if (includedSourceGroups?.length > 0) {
                    <ul class="agpr-saveAsGroupDialog-chipList">
                        @for (group of includedSourceGroups; track group; let i = $index) {
                            <li>
                                <agpr-source-group-chip
                                    [id]="'saveAsGroupDialog_includedSourceGroups_' + i"
                                    [groupId]="+group.entityName"
                                    (remove)="removeGroup(group)"
                                ></agpr-source-group-chip>
                            </li>
                        }
                    </ul>
                }
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="'saveAsGroupDialog_cancel'"
            label="cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="'saveAsGroupDialog_ok'"
            [style]="buttonTypes.primary"
            [disabled]="
                (saveAsOption === saveAsOptions.saveAsNew && groupNameErrors.length > 0) ||
                (saveAsOption === saveAsOptions.saveToExisting && !selectedGroup) ||
                (!selectedSources.length && !includedSourceGroups.length)"
            label="save"
            (click)="confirm()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
